var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !_vm.orders.length && !_vm.preloader
        ? _c("no-orders")
        : _c("div", { staticClass: "section" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v("histórico de limpezas")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons-filters" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn bg-pink",
                      attrs: { to: { name: "purchase-flow" } }
                    },
                    [_vm._v("fazer novo pedido")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "orders" },
              _vm._l(_vm.orders, function(order, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "card" },
                  [
                    _c("div", { staticClass: "professional-image" }, [
                      _c("img", {
                        attrs: {
                          src:
                            order.professional.account.profile.profile_picture,
                          alt: order.professional.account.first_name
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order-informations" }, [
                      _c("div", { staticClass: "name" }, [
                        _vm._v(
                          _vm._s(order.professional.account.first_name) +
                            " " +
                            _vm._s(order.professional.account.last_name)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "status" }, [
                        _c("img", {
                          staticClass: "status-image",
                          attrs: { src: _vm._f("getIcon")(order.status) }
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("getTranslatedName")(order.status)) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "dia " +
                            _vm._s(
                              _vm._f("formatDate")(
                                order.schedule_event.starts_at,
                                "DD/MM/Y [às] H[h]"
                              )
                            ) +
                            " com duração de " +
                            _vm._s(
                              _vm._f("secToHours")(
                                order.schedule_event.duration,
                                true
                              )
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn bg-purple-outline btn-small mt-10",
                        attrs: { to: "pedidos/" + order.id }
                      },
                      [_vm._v("ver mais")]
                    )
                  ],
                  1
                )
              })
            ),
            _vm._v(" "),
            _vm.pagination.current < _vm.pagination.totalPages
              ? _c(
                  "div",
                  {
                    staticClass: "btn bg-purple mt-20",
                    class: { "btn--loading": _vm.preloader },
                    on: {
                      click: function($event) {
                        _vm.setCurrentPage(_vm.pagination.current + 1)
                      }
                    }
                  },
                  [_c("span", [_vm._v("carregar mais")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.pagination.current >= _vm.pagination.totalPages && _vm.preloader
              ? _c("div", { staticClass: "btn bg-purple btn--loading mt-20" })
              : _vm._e()
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f5df60b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f5df60b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderHistory/Mobile.vue
// module id = null
// module chunks = 